const projectRouter = {
  route: null,
  name: null,
  title: '项目管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'views/d_project/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '我的项目',
      type: 'view',
      name: 'projectmgr',
      route: '/d_project/project',
      filePath: 'plugins/d_project/views/ProjectSetting.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '项目信息',
      type: 'view',
      name: 'projectinfo',
      route: '/d_project/info',
      filePath: 'plugins/d_project/views/ProjectInfo.vue',
      inNav: false,
      icon: 'iconfont icon-tushuguanli',
      noReuse: true,
    },
    {
      title: '中奖信息',
      type: 'view',
      name: 'winner',
      route: '/d_project/winner',
      filePath: 'plugins/d_project/views/WinnerInfo.vue',
      inNav: false,
      icon: 'iconfont icon-tushuguanli',
      noReuse: true,
    },
    {
      title: '销售管理',
      type: 'view',
      name: 'salesman',
      route: '/d_project/salesman',
      filePath: 'plugins/d_project/views/sales/SalesmanList.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default projectRouter

